import { Controller } from "@hotwired/stimulus"

// Basis der Schritt-Controller des Stationslaufs (config_tool/run_controller.js ruft perform(run) und reset()):
// eine Statuszeile (target "status") und eine Ausgabe (target "output", z.B. die der CLI), immer als Text, nie als
// Markup. failed() zeigt den Fehler und wirft ihn weiter, damit der Lauf den Schritt als gescheitert markiert.
// logLines liefert die Ausgabe für das Produktionsprotokoll (dmct.md #27); nie etwas Geheimes hineinschreiben.
export default class StepController extends Controller {
  static targets = ["status", "output"]

  reset() {
    this.status("")
    this.outputTarget.hidden = true
    this.outputTarget.textContent = ""
    this.outputTarget.classList.remove("text-danger")
  }

  status(text) {
    this.statusTarget.textContent = text
  }

  output(text, failed = false) {
    this.outputTarget.textContent = text
    this.outputTarget.classList.toggle("text-danger", failed)
    this.outputTarget.hidden = false
  }

  failed(error) {
    this.status("")
    this.output(error.message, true)
    throw error
  }

  get logLines() {
    return this.outputTarget.textContent.split("\n")
  }

  get bridge() {
    return window.configTool
  }
}

// Fehler mit Fehlerart (kind) für Protokoll und Rollbar; die Meldung ist übersetzt, kind bleibt stabil.
// "cancelled" zählt nicht als Fehler (Ergebnis cancelled, kein Rollbar).
export class StepError extends Error {
  constructor(kind, message) {
    super(message)
    this.kind = kind
  }
}

// Fehlermeldungen der Shell (STM32_Programmer_CLI, Einstellungen), die eine Fehlerart haben. Reihenfolge zählt: die
// erste passende gewinnt. no_probe, no_target und setup sind Betriebsfehler an der Station (Rollbar-Warnung).
const SHELL_ERRORS = [
  ["no_probe", /No debug probe detected|No ST-?LINK/i],
  // Ohne Zielplatine bricht die CLI auf macOS nur mit libusb-Timeouts ab, ohne eigene Fehlermeldung.
  ["no_target", /No STM32 target found|Unable to get core ID|target voltage|transfer error: timed out/i],
  ["setup", /not configured|Check the ST-Link utility folder|cannot run FUS operations/i],
  ["cli", /STM32_Programmer_CLI/i],
]

export function errorKind(error) {
  if (error?.kind) return error.kind
  const message = String(error?.message ?? error)
  return SHELL_ERRORS.find(([, pattern]) => pattern.test(message))?.[0] ?? "error"
}
